import { css } from "@emotion/css";

import { yellow } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

import backgroundSrc from "../icons/background.png";

export const createSignInPageStyles = ({
  spacing,
  typography,
  breakpoints,
  viewportHeight,
  palette,
}: Theme) => {
  return {
    pageBoxWrapper: css({
      height: "100%",
      display: "grid",
      gridTemplateRows: "2fr 1fr",
    }),
    welcomeWrapper: css({
      backgroundImage: `url(${backgroundSrc})`,
      backgroundSize: "contain",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    }),
    welcomeText: css({
      position: "relative",
      top: "25%",
      padding: spacing([0, 3]),
      [viewportHeight.down.md]: {
        top: "20%",
        fontSize: typography.pxToRem(24),
      },
    }),
    formWrapper: css({
      margin: spacing([0, -1]),
      [breakpoints.up.sm]: {
        width: 318,
      },
    }),
    forgotPassword: css({
      fontSize: typography.pxToRem(11),
      color: palette.primary.dark,
      textDecoration: "none",
      "&:hover": {
        color: yellow[900],
      },
      "&:focus": {
        color: palette.primary.dark,
      },
    }),
    buttonsWrapper: css({
      display: "flex",
      justifyContent: "space-between",
      textAlign: "right",
      marginTop: spacing(3),
    }),
    submitButton: css({
      minWidth: 130,
    }),
  };
};
